import React, { ReactNode } from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import SpecificationsSkeletonList from 'src/pages/Item/skeletons/SpecificationsSkeletonList';
import DocumentsSkeletonGrid from 'src/components/Documents/skeletons/DocumentsSkeletonGrid';

const ASSET_TAB_SKELETON_ROW_COUNT: number = 4;

// Generic fallback for tabs without a dedicated skeleton. Kept as default
// export so existing imports keep working.
const AssetTabSkeleton = () => (
  <div style={{ padding: '1rem' }}>
    {Array.from({ length: ASSET_TAB_SKELETON_ROW_COUNT }, (_, index: number) => (
      <div key={`asset-tab-skeleton-${index}`} style={{ marginBottom: '0.75rem' }}>
        <Skeleton variant="rect" width="100%" height="3rem" />
      </div>
    ))}
  </div>
);

// Dispatches to the skeleton matching the real tab body (Specifications card
// list, Documents grid, etc). Tabs without a tailored skeleton fall back to
// the generic block layout above.
export const getAssetTabSkeleton = (label: string): ReactNode => {
  if (label === 'Specifications') {
    return <SpecificationsSkeletonList />;
  }
  if (label === 'Manuals & Documents') {
    return <DocumentsSkeletonGrid />;
  }
  return <AssetTabSkeleton />;
};

export default AssetTabSkeleton;
